<section ngClass.lt-sm="small">
  <div class="title-container" fxLayout="row">
    <h2 fxFlex="1 1 auto" class="left-title">Denk Dran!</h2>
    <h2 fxHide.lt-md class="center-title">Checklisten - für Deine Planung</h2>
    <h2 fxHide.lt-md fxFlex="1 1 auto" class="center-clone">Denk Dran!</h2>
  </div>

  <div class="checkliste-container">
    <button *ngIf="!succeded && step == 2" mat-flat-button color="accent" (click)="sendChecklistenRequest()"
            class="cta-button no-margin-top" ngClass.lt-sm="small">Deine Checkliste als
      Word-Dokument
    </button>
    <div *ngIf="!succeded && step > 0" class="description-buttons" fxLayout="row" fxLayout.lt-md="column"
         fxLayoutGap="10px">
      <button *ngIf="!succeded && step > 0" mat-flat-button (click)="step = 0" class="description-button"
              ngClass.lt-sm="small" [fxFlex.gt-sm]="step > 1 ? 60 : 100">
        <mat-icon>keyboard_arrow_left</mat-icon>
        <span>Deine Branche{{selectedBranche ? ': ' + getSelectedBranchenName() : ''}}</span>
      </button>

      <button *ngIf="!succeded && step > 1" mat-flat-button (click)="step = 1" class="description-button"
              ngClass.lt-sm="small" fxFlex.gt-sm="40">
        <mat-icon>keyboard_arrow_left</mat-icon>
        <span>Deine Visitenkarte</span>
      </button>
    </div>

    <div *ngIf="!succeded && stepDescriptions && stepDescriptions[step] && stepDescriptions[step] != ''"
         class="stepDescription">
      <div>{{stepDescriptions[step]}}</div>
      <small *ngIf="!succeded && step == 1">* Pflichtfelder</small>
    </div>

    <form>
      <mat-form-field *ngIf="!succeded && step == 0" appearance="outline" color="primary">
        <mat-label>Branche</mat-label>
        <mat-select #selectHoriz (opened)="branchenSelectOpened(); !cookiesAgreed ? selectHoriz.close() : {}"
                    (selectionChange)="branchenSelectionChange($event)" [(value)]="selectedBranche" tabindex="1">
          <mat-option *ngFor="let branche of branchen" [value]="branche.id">{{branche.name}}</mat-option>
        </mat-select>
      </mat-form-field>
    </form>

    <form>
      <div *ngIf="!succeded && step == 1" fxLayout="column" fxLayoutGap="2px">
        <mat-form-field appearance="outline" color="accent">
          <mat-label>Name</mat-label>
          <input matInput [(ngModel)]="name" type="text" (focus)="inputFocus($event, false)"
                 (blur)="inputFocus($event, true); validateName()" name="name" tabindex="1" required>
          <mat-error *ngIf="nameError">{{nameError}}</mat-error>
        </mat-form-field>
        <mat-form-field appearance="outline" color="accent">
          <mat-label>E-Mail Adresse</mat-label>
          <input matInput [(ngModel)]="email" type="text" (focus)="inputFocus($event, false)"
                 (blur)="inputFocus($event, true); validateEmail()" name="email" tabindex="2" required>
          <mat-error *ngIf="emailError">{{emailError}}</mat-error>
        </mat-form-field>
        <mat-form-field appearance="outline" color="accent">
          <mat-label>Telefonnummer</mat-label>
          <input matInput [(ngModel)]="telefon" type="text" (focus)="inputFocus($event, false)"
                 (blur)="inputFocus($event, true); validateTelefon()" name="telefon" tabindex="3" required>
          <mat-error *ngIf="telefonError">{{telefonError}}</mat-error>
        </mat-form-field>
        <button mat-flat-button color="accent" (click)="gotoStep2()" class="cta-button" ngClass.lt-sm="small">Hol Dir
          Deine Checkliste
        </button>
      </div>
    </form>

    <form>
      <div *ngIf="!succeded && step == 2" fxLayout="column" fxLayoutGap="2px">
        <mat-form-field appearance="outline" color="accent">
          <mat-label>Firma</mat-label>
          <input matInput [(ngModel)]="firma" type="text" (focus)="inputFocus($event, false)"
                 (blur)="inputFocus($event, true)" name="firma" tabindex="1">
        </mat-form-field>
        <mat-form-field appearance="outline" color="accent">
          <mat-label>Adresse</mat-label>
          <input matInput [(ngModel)]="adresse" type="text" (focus)="inputFocus($event, false)"
                 (blur)="inputFocus($event, true)" name="adresse" tabindex="2">
        </mat-form-field>
        <mat-form-field appearance="outline" color="accent">
          <mat-label>PLZ / Stadt</mat-label>
          <input matInput [(ngModel)]="stadt" type="text" (focus)="inputFocus($event, false)"
                 (blur)="inputFocus($event, true)" name="stadt" tabindex="3">
        </mat-form-field>
        <mat-form-field appearance="outline" color="accent">
          <mat-label>Bemerkungen</mat-label>
          <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="4"
                    cdkAutosizeMaxRows="6" [(ngModel)]="bemerkungen" (focus)="inputFocus($event, false)"
                    (blur)="inputFocus($event, true)" name="bemerkungen" tabindex="4"></textarea>
        </mat-form-field>
        <div class="checkboxes" fxLayout="column" fxLayoutAlign="center start">
          <small>Terminvereinbarung gewünscht per</small>
          <mat-checkbox [(ngModel)]="kontaktPerMail" name="kontaktPerMail" tabindex="5">E-Mail</mat-checkbox>
          <mat-checkbox [(ngModel)]="kontaktPerTelefon" name="kontaktPerTelefon" tabindex="6">Telefon</mat-checkbox>
        </div>
        <button mat-flat-button color="accent" (click)="sendChecklistenRequest()"
                class="cta-button" ngClass.lt-sm="small">Deine Checkliste als Word-Dokument
        </button>
      </div>
    </form>

    <div *ngIf="!succeded && error" class="error">
      <mat-error>{{error}}</mat-error>
    </div>

    <div *ngIf="succeded && !error" class="success-animation" fxLayout="column" fxLayoutAlign="center center">
      <svg id="successAnimation" class="animated" xmlns="http://www.w3.org/2000/svg" width="70" height="70"
           viewBox="0 0 70 70">
        <path id="successAnimationResult" fill="#D8D8D8"
              d="M35,60 C21.1928813,60 10,48.8071187 10,35 C10,21.1928813 21.1928813,10 35,10 C48.8071187,10 60,21.1928813 60,35 C60,48.8071187 48.8071187,60 35,60 Z M23.6332378,33.2260427 L22.3667622,34.7739573 L34.1433655,44.40936 L47.776114,27.6305926 L46.223886,26.3694074 L33.8566345,41.59064 L23.6332378,33.2260427 Z"/>
        <circle id="successAnimationCircle" cx="35" cy="35" r="24" stroke="#979797" stroke-width="2"
                stroke-linecap="round" fill="transparent"/>
        <polyline id="successAnimationCheck" stroke="#979797" stroke-width="2" points="23 34 34 43 47 27"
                  fill="transparent"/>
      </svg>
      <small>Deine Checkliste ist nun auf dem Weg.</small>
      <button mat-flat-button color="accent" class="cta-button" (click)="resetCheckliste()" ngClass.lt-sm="small">Neue
        Checkliste anfordern
      </button>
    </div>

    <div class="container" [ngClass.lt-md]="{'small': true}" (contextmenu)="onContextMenu($event)"
         [ngStyle]="{'height': getPreviewHeight() + 'px'}">
      <div class="checklisten-wrapper">
        <perfect-scrollbar>
          <img #checklistImage class="checklisten-vorschau"
               src="../../../assets/images/checklisten/checkliste_dummy.jpg"/>
        </perfect-scrollbar>
      </div>
      <div class="watermark">www.abc-complett.de</div>
      <button *ngIf="!succeded && step == 2" class="checkliste-button" mat-flat-button>Deine Checkliste als
        Word-Dokument
      </button>
    </div>
  </div>
</section>
